import { PropsWithChildren } from "react";
import {
  SheetFooter
} from "src/components/shadcn";
import SidebarBase from "../../common/SidebarBase";

export type SidebarProps = PropsWithChildren & {
  title?: React.ReactNode;
  isSidebarOpen: boolean;
  onSidebarToggleClick: (isOpen?: boolean) => void;
  size?: "sm" | "md" | "lg";
  footer?: React.ReactNode;
  offsetHeight?: number;
};

const Sidebar = ({
  title = "",
  children,
  footer,
  isSidebarOpen,
  onSidebarToggleClick,
  size = "md",
  offsetHeight = 0,
}: SidebarProps) => (
  <SidebarBase
    isSidebarOpen={isSidebarOpen}
    onSidebarToggleClick={onSidebarToggleClick}
    size={size}
    offsetHeight={offsetHeight}
    title={title}
  >
    {/* The scrollable area */}
    <div className="flex-1 overflow-y-auto pr-4">{children}</div>
    {/* Optional footer */}
    {footer && <SheetFooter className="mt-2">{footer}</SheetFooter>}
  </SidebarBase>
);

export default Sidebar;
